import { render } from "./reloading-carousel.vue?vue&type=template&id=01e2bd16"
import script from "./reloading-carousel.vue?vue&type=script&lang=js"
export * from "./reloading-carousel.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Work/Sneak-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__